module.exports = __webpack_public_path__ + "img/cch2.1f78c2b9.jpg";